import { render, staticRenderFns } from "./RptSalTraDet.vue?vue&type=template&id=57534c15&scoped=true"
import script from "./RptSalTraDet.vue?vue&type=script&lang=js"
export * from "./RptSalTraDet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57534c15",
  null
  
)

export default component.exports